let routingMappings = new Map();

routingMappings.set("home", "/");
routingMappings.set("courses", "/courses");
routingMappings.set("tutors", "/tutors");
routingMappings.set("about", "/about");
routingMappings.set("contact", "/contact");

export default routingMappings;